var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccessGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 16.5C32.5 25.3365 25.3365 32.5 16.5 32.5C7.66343 32.5 0.5 25.3365 0.5 16.5C0.5 7.66343 7.66343 0.5 16.5 0.5C25.3365 0.5 32.5 7.66343 32.5 16.5Z",
    fill: "#C2DCBC",
    stroke: "#6F8165"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.3069,
    y: 23.5844,
    width: 10.2892,
    height: 2.76822,
    rx: 1,
    transform: "rotate(-140 15.3069 23.5844)",
    fill: "#637459"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3885,
    y: 21.8903,
    width: 15.6523,
    height: 2.68379,
    rx: 1,
    transform: "rotate(-50 13.3885 21.8903)",
    fill: "#637459"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessGreen);
export default __webpack_public_path__ + "static/media/Icon_Success_Green.1d45c3899bca771e9ca168c32a341bfe.svg";
export { ForwardRef as ReactComponent };